import { Link, useLocation } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import PageSeo from '@/components/feature/PageSeo';
import { channels } from '@/mocks/channels';

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <PageSeo
        title="页面走丢了 - 糖心吃瓜网"
        description="你要找的页面可能已经被吃完了，回到糖心吃瓜网首页继续摸鱼吧。"
        keywords="糖心吃瓜网,404"
        canonical="https://renrenmingxiao.cn/"
      />
      <SiteHeader />
      <main className="mx-auto flex max-w-[1400px] flex-col items-center px-4 py-24 text-center md:px-6">
        <span className="flex h-20 w-20 items-center justify-center rounded-3xl bg-primary-100 text-primary-600">
          <i className="ri-emotion-laugh-line w-10 h-10 flex items-center justify-center text-5xl" />
        </span>
        <p className="mt-6 font-heading text-5xl text-background-300 md:text-7xl">404</p>
        <h1 className="mt-4 font-heading text-2xl text-foreground-950 md:text-3xl">
          这个瓜好像被吃完了
        </h1>
        <p className="mt-3 max-w-md text-sm text-foreground-600">
          页面可能已下线，或者链接不太对。不如换个专栏继续乐呵？
        </p>
        <p className="mt-2 text-xs text-foreground-400">{location.pathname}</p>

        <div className="mt-8 flex flex-wrap justify-center gap-2">
          {channels.slice(0, 4).map((channel) => (
            <Link
              key={channel.slug}
              to={`/channel/${channel.slug}`}
              className="whitespace-nowrap rounded-full border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              {channel.name}
            </Link>
          ))}
        </div>

        <Link
          to="/"
          className="mt-8 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          回到首页
        </Link>
      </main>
      <SiteFooter />
    </>
  );
}